export default __webpack_public_path__ + "static/media/epi.869cb698.png";